import {
  Checkbox,
  Chip,
  Stack,
  TableCell,
  TableRow,
  Tooltip,
} from '@mui/material';
import { ComparisonRow } from './customerImportTypes';
import { formatDiscount } from './customerImportUtils';

type CustomerImportRowProps = {
  row: ComparisonRow;
  isSelected: boolean;
  onToggleRow(row: ComparisonRow): void;
};

function CustomerImportRow({
  row,
  isSelected,
  onToggleRow,
}: CustomerImportRowProps) {
  function getStatusColor(status: ComparisonRow['status']) {
    switch (status) {
      case 'add':
        return 'success';
      case 'modify':
        return 'warning';
      case 'remove':
        return 'error';
      default:
        return 'default';
    }
  }

  function getStatusLabel(status: ComparisonRow['status']) {
    switch (status) {
      case 'add':
        return 'Lisää';
      case 'modify':
        return 'Päivitä';
      case 'remove':
        return 'Poista';
      default:
        return 'Ei muutoksia';
    }
  }

  function handleToggle() {
    onToggleRow(row);
  }

  const errorMessage = row.errorLabel ?? row.invalidReason ?? null;

  const sqlName = row.sql?.name ?? '-';
  const miraName = row.mira?.clientName ?? '-';
  const sqlBusinessId = row.sql?.businessId ?? '-';
  const miraBusinessId = row.mira?.businessId ?? '-';
  const sqlDiscount = formatDiscount(row.sql?.discount);
  const miraDiscount = formatDiscount(
    row.mira?.transportationDiscount,
  );
  const showComparison = row.status === 'modify';

  return (
    <TableRow>
      <TableCell>
        <Tooltip
          title={errorMessage ?? ''}
          disableHoverListener={!errorMessage}
        >
          <span>
            <Checkbox
              checked={Boolean(isSelected)}
              disabled={
                row.status === 'unchanged' ||
                row.hasMissingData ||
                Boolean(row.invalidReason)
              }
              onChange={handleToggle}
            />
          </span>
        </Tooltip>
      </TableCell>
      <TableCell>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          flexWrap="nowrap"
        >
          <Chip
            label={getStatusLabel(row.status)}
            color={getStatusColor(row.status)}
            size="small"
          />
          {row.hasMissingData && (
            <Tooltip
              title={errorMessage ?? ''}
              disableHoverListener={!errorMessage}
            >
              <Chip
                label="Virhe"
                color="default"
                variant="outlined"
                size="small"
                sx={{ color: '#d32f2f', borderColor: '#d32f2f' }}
              />
            </Tooltip>
          )}
        </Stack>
      </TableCell>
      <TableCell>
        {row.mira?.clientId || row.sql?.customerId || '-'}
      </TableCell>
      <TableCell>
        {showComparison
          ? `${sqlName} → ${miraName}`
          : row.status === 'add'
            ? miraName
            : sqlName}
      </TableCell>
      <TableCell>
        {showComparison
          ? `${sqlBusinessId} → ${miraBusinessId}`
          : row.status === 'add'
            ? miraBusinessId
            : sqlBusinessId}
      </TableCell>
      <TableCell>
        {showComparison
          ? `${sqlDiscount} → ${miraDiscount}`
          : row.status === 'add'
            ? miraDiscount
            : sqlDiscount}
      </TableCell>
    </TableRow>
  );
}

export default CustomerImportRow;
